export const environment = {
  production: false,
};

export const environmentURL = {
  production: false,
  apiBaseUrl: 'https://sdm-ms.azurewebsites.net/api',
  apiBackendUrl: 'https://sdm-backend.azurewebsites.net/api',
  sessionTimeOut: 24 * 60 * 60 * 1000,
  portalAppClientToken: 'MobileApp1039',
  portalAppVersion: '1.0.1',
  portalAppAmbiente: 'dev',
  cloudflareTurnstileSiteKey: '0x4AAAAAADmCPKD01MimuMfs',
};
